module.exports = __webpack_public_path__ + "img/Dani.abf529e8.jpg";